// Resolve os subitens de um módulo no contexto CLIENTE. Diferente da gestão (que
// herda os subRoutes prontos do buildRoutes), o CLIENTE_GROUPS monta itens sem
// subrotas — então reaproveitamos as MESMAS funções de subrotas de cada módulo
// (as que alimentam a topbar). Só mapeamos módulos cujas funções JÁ retornam a
// lista FILTRADA por acesso, para nunca expor subrota sem permissão:
//   - consolidador (carteira): consolidadorOptionsRoutes filtra por hasAccess
//   - compliance: complianceRoutes filtra por hasAccess
// CRM e demais módulos (cujas funções não filtram, ou não têm função de subrotas)
// ficam sem flyout por ora — follow-up. Sem resolver => [] (degradação graciosa).
import { consolidadorOptionsRoutes } from '@modules/consolidator/constants/Text'
import { complianceRoutes } from '@modules/compliance/constants/Text'
import { routeModuleKey } from '@modules/navegacao-v2/utils/visible-modules'

// moduleKey (1º segmento do routeName) → função que devolve as subrotas já filtradas.
// A assinatura difere por módulo; o adaptador chama cada uma na ordem correta.
const SUBITEM_RESOLVERS = {
  carteira: (access, currentUser) => consolidadorOptionsRoutes(currentUser, access),
  compliance: (access, currentUser) => complianceRoutes(access, currentUser),
}

function toClienteSubitem(route) {
  return {
    key: route.name,
    label: (route.title || '').trim(),
    routeName: route.name,
  }
}

/**
 * Subitens (shape da nav 2026) de um módulo do contexto cliente.
 * @param {string} moduleKey  chave de módulo (1º segmento do routeName)
 * @param {Object} access     store.getters['parameters/show']
 * @param {Object} currentUser this.$currentUser()
 * @returns {Array<{ key, label, routeName }>}
 */
export function subitemsForModule(moduleKey, access, currentUser) {
  const resolver = SUBITEM_RESOLVERS[moduleKey]
  if (!resolver) return []
  const routes = resolver(access || {}, currentUser || {}) || []
  return routes.map(toClienteSubitem)
}

/**
 * Injeta `subitems` nos itens dos grupos do contexto cliente cujo módulo tem
 * resolver conhecido. Função pura — não muta os grupos de entrada.
 * @param {Array} groups  saída de visibleGroups(CLIENTE_GROUPS, ...)
 * @param {Object} access store.getters['parameters/show']
 * @param {Object} currentUser this.$currentUser()
 * @returns {Array} grupos com `subitems` nos itens aplicáveis
 */
export function withClienteSubitems(groups, access, currentUser) {
  return groups.map((group) => ({
    ...group,
    items: group.items.map((item) => {
      const subitems = subitemsForModule(
        routeModuleKey(item.routeName),
        access,
        currentUser
      )
      return subitems.length ? { ...item, subitems } : item
    }),
  }))
}
